import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC<{
  menuCollapsed?: boolean;
  style?: React.CSSProperties;
}> = ({ menuCollapsed = false, style = {} }) => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
        opacity: 0.5,
        paddingRight: menuCollapsed ? '64px' : '256px',
        transition: 'padding-right 0.3s ease-in-out',
        ...style,
      }}
      copyright="Powered by SUNRIZ"
    />
  );
};

export default Footer;
